module.exports = __webpack_public_path__ + "static/media/marriott-copley.640bd79d.jpg";